import Environment from "../../utils/environment";

/**
 * 旅CUBEのURLを取得する。
 * @param searchParams URLパラメーター。（例. ?lang=en）
 * @returns パラメーターを含めた旅CUBEのURL。
 */
export function getTabicubeUrl(searchParams: string) {
  /** 環境変数で指定された環境種別を識別するための値。 */
  const env = process.env['REACT_APP_STAGE_ENV'] || '';
  // 本番環境の場合は本番環境用URLを、それ以外の場合はステージング環境URLを返却する。
  return Environment.isProduction(env) ?
    getTabicubeProductionUrl(searchParams) :
    getTabicubeStagingUrl(searchParams);
}

/**
 * 旅CUBEの本番環境URLを取得する。
 * @param searchParams URLパラメーター。（例. ?lang=en）
 * @returns パラメーターを含めた本番環境の旅CUBEのURL。
 */
export function getTabicubeProductionUrl(searchParams: string) {
  return `https://tabicube.com${searchParams}`;
}

/**
 * 旅CUBEのステージング環境URLを取得する。
 * @param searchParams URLパラメーター。（例. ?lang=en）
 * @returns パラメーターを含めたステージング環境の旅CUBEのURL。
 */
export function getTabicubeStagingUrl(searchParams: string) {
  return `https://stg.tabicube.com${searchParams}`;
}

/**
 * 現在表示しているパスがそらたび（/public以下のパス）であるかを判定する。
 * @param pathname 表示しているページのパス名。
 * @returns 現在表示しているパスがそらたび（/public以下のパス）であるかを判定した結果。
 */
export function isSoratabi(pathname: string) {
  return pathname.includes('/public');
}

/**
 * そらたびの場合にURLパラメーターを整形する。
 * @param searchParams URLパラメーター部分の文字列。
 * @returns 整形後のURLパラメーター。
 */
export function modifySoratabiParams(searchParams: string) {
  const params = new URLSearchParams(searchParams);
  // 必ず「referrer=aswdms」を追加する。
  params.set('referrer', 'aswdms');
  return `?${params.toString()}`;
}

/**
 * 広島空港連携の場合にURLパラメーターを整形する。
 * @param searchParams URLパラメーター部分の文字列。
 * @returns 整形後のURLパラメーター。
 */
export function modifyHiroshimaParams(searchParams: string) {
  const params = new URLSearchParams(searchParams);
  /** stdパラメーターの値。 */
  const std = params.get('std');
  /** staパラメーターの値。 */
  const sta = params.get('sta');
  // stdパラメーターに年月日のみ設定されている場合、時刻を追加する。
  if (std !== null && hasNotTime(std)) {
    /** 日付に時刻（午前0時）を追加した値。 */
    const added = add0am(std);
    params.set('std', added);
  }
  // staパラメーターに年月日のみ設定されている場合、時刻を追加する。
  if (sta !== null && hasNotTime(sta)) {
    /** 日付に時刻（午前1時）を追加した値。 */
    const added = add1am(sta);
    params.set('sta', added);
  }
  return `?${params.toString()}`;

}

/**
 * URLパラメーターから広島連携であるかを判定する。
 * @param searchParams URLパラメーター。
 * @returns URLパラメーターから広島連携であるかを判定した結果。
 */
export function isHiroshimaAirport(searchParams: string) {
  return searchParams.includes('referrer=hijapo');
}

/**
 * 時刻が未設定（数字8ケタの値）であるかを判定する。
 * @param value 判定したい文字列。
 * @returns 時刻が未設定であるか判定した結果。
 */
export function hasNotTime(value: string) {
  const regexp = RegExp(/^\d{8}$/);
  return regexp.test(value);
}

/**
 * yyyyMMdd形式の年月日にHHmm形式の午前0時を追加する。
 * @param value 年月日の文字列。
 * @returns yyyyMMddHHmm形式の日時の文字列。
 */
export function add0am(value: string) {
  return value.concat('0000');
}

/**
 * yyyyMMdd形式の年月日にHHmm形式の午前1時を追加する。
 * @param value 年月日の文字列。
 * @returns yyyyMMddHHmm形式の日時の文字列。
 */
export function add1am(value: string) {
  return value.concat('0100');
}
